import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=38c72d7a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c72d7a')) {
      api.createRecord('38c72d7a', component.options)
    } else {
      api.reload('38c72d7a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=38c72d7a&", function () {
      api.rerender('38c72d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29ZFcY97A4d0y/JS/comp/ImgFallback.vue"
export default component.exports